import { createSelector } from 'reselect';

import { selector } from './reducer';

export default {
    loggedIn: createSelector(selector, (auth) => !!auth.accessToken),
    token: createSelector(selector, (auth) => auth.accessToken),
    user: createSelector(selector, (auth) => auth.user),
    accountmanager: createSelector(selector, (auth) => auth.accountmanager),    
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/selectors.tsx